import { IForm } from '@/components/types'

export const modalConfig: IForm = {
  formItems: [
    {
      field: 'name',
      type: 'input',
      label: '权限名',
      placeholder: '请输入权限名',
      rules: { required: true, message: '权限名是必传的', trigger: 'blur' }
    },
    {
      field: 'sort',
      type: 'input',
      label: '排序',
      placeholder: '请输入排序值 0-100 之间',
      rules: { required: true, message: '排序必传的', trigger: 'blur' }
    }
  ],
  colLayout: 24,
  itemStyle: {}
}
